/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";
import { IoFolder, IoTrash, IoEllipsisVertical } from "react-icons/io5";
import { DropdownButton, NavItem } from "react-bootstrap";
import matchSorter from "match-sorter";
import ReactTable from "react-table";

import { formatDate } from "../../../helpers/date";

const ProjectTaskList = ({
  project,
  search,
  isMobile,
  onClickCheck,
  onClickEdit,
  onClickDelete
}) => {
  const columns = !isMobile
    ? [
        {
          accessor: "is_complete",
          Cell: (row) => (
            <input
              type="checkbox"
              onClick={() => onClickCheck(row.original._id)}
              checked={row.value}
            />
          ),
          Header: "Status",
          sortable: false,
          filterable: false,
          id: "is_complete",
          maxWidth: 60,
          style: {
            textAlign: "center"
          }
        },
        {
          Header: "Task",
          accessor: "description",
          id: "description"
        },
        {
          Header: "Assigned To",
          accessor: "assigned_to.full_name"
        },
        {
          Header: "Priority",
          accessor: "priority.label"
        },
        {
          Header: "Estimated Hrs",
          accessor: "estimated_hrs",
          id: "estimated_hrs"
        },
        {
          Header: "Created On",
          accessor: "created_on",
          Cell: (row) => formatDate(row.value, "MM/dd/yyyy - hh:mm a")
        }
      ]
    : [
        {
          accessor: "_id",
          Cell: (row) => (
            <input
              type="checkbox"
              onClick={() => onClickCheck(row.value)}
              checked={row.original.is_complete}
            />
          ),
          sortable: false,
          filterable: false,
          maxWidth: 60,
          style: {
            textAlign: "center"
          }
        },
        {
          Header: "Task",
          accessor: "description"
        }
      ];

  columns.push({
    Header: "",
    accessor: "_id",
    maxWidth: 80,
    sortable: false,
    Cell: (row) => (
      <div className="text-center actions">
        <DropdownButton
          title={
            <span>
              <IoEllipsisVertical />
            </span>
          }
          id="dropdown"
        >
          <NavItem onClick={() => onClickEdit(row.value)}>
            <IoFolder />
            View
          </NavItem>
          <NavItem onClick={() => onClickDelete(row.value)}>
            <IoTrash />
            Delete
          </NavItem>
        </DropdownButton>
      </div>
    )
  });

  const checkboxProps = {
    selectType: "checkbox",
    getTrGroupProps: (state, row) => {
      if (state && row && row.original) {
        const completed = row.original.is_complete;
        return {
          style: {
            textDecoration: completed ? "line-through" : "none"
          }
        };
      }
    }
  };
  let { tasks } = project;
  if (search) {
    tasks = matchSorter(project.tasks, search, {
      keys: ["description", "assigned_to.full_name", "priority.label"]
    });
  }

  return (
    <ReactTable
      className="-highlight"
      data={tasks}
      columns={columns}
      {...checkboxProps}
      defaultPageSize={10}
      showPagination={tasks && tasks.length >= 10}
      sorted={[{ id: "is_complete" }]}
      getTdProps={(state, rowInfo, column) => ({
        onClick: () => {
          if (
            column.id !== "is_complete" &&
            column.id !== "_id" &&
            rowInfo?.original?._id
          ) {
            onClickEdit(rowInfo.original._id);
          }
        }
      })}
      defaultSorted={[
        {
          id: "description",
          asc: true
        }
      ]}
    />
  );
};

ProjectTaskList.propTypes = {
  project: PropTypes.object,
  search: PropTypes.string,
  isMobile: PropTypes.bool,
  onClickCheck: PropTypes.func,
  onClickEdit: PropTypes.func,
  onClickDelete: PropTypes.func
};
export default ProjectTaskList;
